const BillingSVG = (): JSX.Element => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 0C2.7835 0 2 0.783502 2 1.75V19.25C2 20.2165 2.7835 21 3.75 21H14.25C15.2165 21 16 20.2165 16 19.25V4.5L11.5 0H3.75ZM3.5 1.75C3.5 1.61193 3.61193 1.5 3.75 1.5H10.75V5.25C10.75 5.66421 11.0858 6 11.5 6H15.5V19.25C15.5 19.3881 15.3881 19.5 15.25 19.5H3.75C3.61193 19.5 3.5 19.3881 3.5 19.25V1.75ZM12.25 1.81L14.69 4.5H12.25V1.81Z"
        fill="#545556"
      />
      <path d="M5 8.25H13V9.5H5V8.25Z" fill="#545556" />
      <path d="M5 11H13V12.25H5V11Z" fill="#545556" />
      <path d="M5 13.75H10V15H5V13.75Z" fill="#545556" />
    </svg>
  );
};

export default BillingSVG;
